module.exports = __webpack_public_path__ + "static/media/current_city.0121c5bb.svg";